import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardPageComponent } from 'src/app/pages/dashboard/dashboard-page/dashboard-page.component';
import { SharedDashboardComponent } from './shared-dashboard.component';


const routes: Routes = [
    {
        path: '',
        component: DashboardPageComponent
      }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
